import { camelizeKeys } from 'humps'
import productEntities from './product-entities'

const defaultEntities = {
  fields: {},
  locations: {},
  intervals: {},
  openOrders: {},
  players: {},
  products: {},
  reservations: {},
  transactions: {},
  refundedTransactions: {},
  summaryReport: {}
}

const saveEntities = (state, payload, { cleanup } = {}) => {
  const newState = { ...state }
  Object.keys(defaultEntities).forEach((entities) => {
    if (payload[entities]) {
      newState[entities] = cleanup ? {} : { ...state[entities] }
      if (payload[entities].forEach) {
        let ids =
          state[entities].allIds && !cleanup ? state[entities].allIds : []
        payload[entities].forEach((entity) => {
          ids.push(entity.id)
          newState[entities][entity.id] = {
            ...newState[entities][entity.id],
            ...camelizeKeys(entity)
          }
        })
        newState[entities].allIds = Array.from(new Set(ids))
      } else {
        newState[entities] = camelizeKeys(payload[entities])
      }
    }
  })
  return newState
}

const deleteEntity = (state, type, id) => {
  const ids = [...state[type].allIds]
  const index = ids.indexOf(id)
  if (index !== -1) ids.splice(index, 1)
  return { ...state, [type]: { ...state[type], allIds: ids } }
}

const clearEntities = (state, type) => ({ ...state, [type]: { allIds: [] } })

const entities = (state = defaultEntities, { type, payload }) => {
  let newState = state
  switch (type) {
    case 'CALENDAR.INIT':
    case 'PAYMENT_MODAL.INIT':
    case 'SHOP.INIT':
    case 'SHOP_INVENTORY.INIT':
      if (window.App.entities)
        newState = saveEntities(newState, window.App.entities, {
          cleanup: true
        })
      if (window.App.shop)
        newState = saveEntities(newState, window.App.shop, { cleanup: true })
      break
    case 'SHOP_RESERVATIONS_RECEIVED':
    case 'SHOP_PRODUCTS_RECEIVED':
    case 'ENTITIES_RECEIVED':
      newState = saveEntities(state, payload)
      break
    case 'ENTITIES.DELETE':
      newState = deleteEntity(state, payload.type, payload.id)
      break
    case 'ENTITIES.CLEAR':
      newState = clearEntities(state, payload.type)
      break
  }
  return {
    ...newState,
    products: productEntities(newState.products, { type, payload })
  }
}

export default entities
